import {
  POWERBI_REPORTS_DATA,
  POWERBI_ALL_REPORTS_DATA,
  POWERBI_EMBED_URL_DATA,
  POWERBI_REPORT_GET_DATA,
  POWERBI_SET_SELECTED_REPORT,
  POWERBI_SET_PROFILE_VIEW,
  POWERBI_FAVORITES_DATA,
  POWERBI_ADD_FAVORITE,
  POWERBI_REMOVE_FAVORITE,
} from "./Constants";

const initialState = {
  loading: false,
  error: null,
  reports: [],
  allReports: [],
  allReportsLoading: false,
  allReportsError: null,
  selectedReport: null,
  reportDetails: null,
  embedData: null,
  embedLoading: false,
  embedError: null,
  favorites: [],
  favoritesLoading: false,
  favoritesError: null,
  favoriteToggling: false,
  isProfileView: false,
};

const Reducer = (state = initialState, action) => {
  switch (action.type) {
    // ==================== Load Reports List ====================
    case POWERBI_REPORTS_DATA.POWERBI_REPORTS_DATA_LOAD:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case POWERBI_REPORTS_DATA.POWERBI_REPORTS_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        reports: action.reports,
        error: null,
      };
    case POWERBI_REPORTS_DATA.POWERBI_REPORTS_DATA_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
        reports: [],
      };

    // ==================== Load All Reports (No Filter) ====================
    case POWERBI_ALL_REPORTS_DATA.POWERBI_ALL_REPORTS_DATA_LOAD:
      return {
        ...state,
        allReportsLoading: true,
        allReportsError: null,
      };
    case POWERBI_ALL_REPORTS_DATA.POWERBI_ALL_REPORTS_DATA_SUCCESS:
      return {
        ...state,
        allReportsLoading: false,
        allReports: action.allReports,
        allReportsError: null,
      };
    case POWERBI_ALL_REPORTS_DATA.POWERBI_ALL_REPORTS_DATA_FAIL:
      return {
        ...state,
        allReportsLoading: false,
        allReportsError: action.error,
        allReports: [],
      };

    // ==================== Get Report Details ====================
    case POWERBI_REPORT_GET_DATA.POWERBI_REPORT_GET_DATA_LOAD:
      return {
        ...state,
        loading: true,
        reportDetails: null,
        error: null,
      };
    case POWERBI_REPORT_GET_DATA.POWERBI_REPORT_GET_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        reportDetails: action.report,
        error: null,
      };
    case POWERBI_REPORT_GET_DATA.POWERBI_REPORT_GET_DATA_FAIL:
      return {
        ...state,
        loading: false,
        reportDetails: null,
        error: action.error,
      };

    // ==================== Set Selected Report ====================
    case POWERBI_SET_SELECTED_REPORT:
      return {
        ...state,
        selectedReport: action.report,
        embedData: null, // Clear embed data when selecting a new report
        embedError: null,
        isProfileView: false, // Exit profile view when selecting a report
      };

    // ==================== Set Profile View ====================
    case POWERBI_SET_PROFILE_VIEW:
      return {
        ...state,
        isProfileView: action.isProfileView,
        selectedReport: action.isProfileView ? null : state.selectedReport, // Clear selected report when entering profile view
      };

    // ==================== Embed URL ====================
    case POWERBI_EMBED_URL_DATA.POWERBI_EMBED_URL_DATA_LOAD:
      return {
        ...state,
        embedLoading: true,
        embedError: null,
      };
    case POWERBI_EMBED_URL_DATA.POWERBI_EMBED_URL_DATA_SUCCESS:
      return {
        ...state,
        embedLoading: false,
        embedData: action.embedData,
        embedError: null,
      };
    case POWERBI_EMBED_URL_DATA.POWERBI_EMBED_URL_DATA_FAIL:
      return {
        ...state,
        embedLoading: false,
        embedData: null,
        embedError: action.error,
      };

    // ==================== Get Favorite Reports ====================
    case POWERBI_FAVORITES_DATA.POWERBI_FAVORITES_DATA_LOAD:
      return {
        ...state,
        favoritesLoading: true,
        favoritesError: null,
      };
    case POWERBI_FAVORITES_DATA.POWERBI_FAVORITES_DATA_SUCCESS:
      return {
        ...state,
        favoritesLoading: false,
        favorites: action.favorites,
        favoritesError: null,
      };
    case POWERBI_FAVORITES_DATA.POWERBI_FAVORITES_DATA_FAIL:
      return {
        ...state,
        favoritesLoading: false,
        favoritesError: action.error,
      };

    // ==================== Add Favorite ====================
    case POWERBI_ADD_FAVORITE.POWERBI_ADD_FAVORITE_LOAD:
      return {
        ...state,
        favoriteToggling: true,
      };
    case POWERBI_ADD_FAVORITE.POWERBI_ADD_FAVORITE_SUCCESS:
      return {
        ...state,
        favoriteToggling: false,
        favorites: [...state.favorites, { report_id: action.reportId, id: action.reportId }],
      };
    case POWERBI_ADD_FAVORITE.POWERBI_ADD_FAVORITE_FAIL:
      return {
        ...state,
        favoriteToggling: false,
        favoritesError: action.error,
      };

    // ==================== Remove Favorite ====================
    case POWERBI_REMOVE_FAVORITE.POWERBI_REMOVE_FAVORITE_LOAD:
      return {
        ...state,
        favoriteToggling: true,
      };
    case POWERBI_REMOVE_FAVORITE.POWERBI_REMOVE_FAVORITE_SUCCESS:
      return {
        ...state,
        favoriteToggling: false,
        favorites: state.favorites.filter(
          fav => (fav.report_id || fav.id) !== action.reportId
        ),
      };
    case POWERBI_REMOVE_FAVORITE.POWERBI_REMOVE_FAVORITE_FAIL:
      return {
        ...state,
        favoriteToggling: false,
        favoritesError: action.error,
      };

    default:
      return {
        ...state,
      };
  }
};

export default Reducer;
